export const theme = {
	primaryDark: '#000000',
	primaryLight: '#FFFFFF',
	primaryHover: '#ffdd55',
	mobile: '576px',
};
